import { Box, Typography } from '@mui/material';

import { TextButton } from './TextButton';
import { LIST } from './tokens';

export function SelectionBanner({
  label,
  selectAllLabel,
  onSelectAll,
  onClear,
}: {
  label: string;
  selectAllLabel: string | null;
  onSelectAll: () => void;
  onClear: () => void;
}) {
  return (
    <Box
      data-testid="selection-banner"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        px: '16px',
        py: '8px',
        bgcolor: LIST.selectedBg,
        fontFamily: LIST.font,
        fontSize: 16,
        lineHeight: '24px',
        color: LIST.ink,
      }}
    >
      <Typography component="span" sx={{ font: 'inherit', fontWeight: 600 }}>
        {label}
      </Typography>
      {selectAllLabel !== null && (
        <>
          <Box component="span" aria-hidden="true">·</Box>
          <TextButton label={selectAllLabel} onClick={onSelectAll} />
        </>
      )}
      <Box component="span" aria-hidden="true">·</Box>
      <TextButton label="Clear" onClick={onClear} />
    </Box>
  );
}
